<div class="card">
    <p-fieldset legend="Upload Shipment File" [toggleable]="false">
        <div class="formgrid grid">
            <div class="field col-12">
                <p-inputGroup>
                    <p-inputGroupAddon><i class="pi pi-th-large"></i></p-inputGroupAddon>
                    <p-iftaLabel>
                        <p-select id="location-type" [options]="fileTypes" [(ngModel)]="selectedFileType"
                                    placeholder="File Type" [disabled]="lockFileType" styleClass="w-full">
                        </p-select>
                        <label for="location-type">File Type</label>
                    </p-iftaLabel>
                </p-inputGroup>
            </div>
            <div class="field col-12">
                <p-fileUpload name="jobAttachmentUpload" (uploadHandler)="onShipmentFileUpload($event)" (onSelect)="onSelect($event)"
                              (onClear)="clearSelection()"
                              [multiple]="allowMultiple" [accept]="acceptedFileTypes" [customUpload]="true"
                              [maxFileSize]="maxFileSize" [disabled]="uploadOngoing" styleClass="w-full">
                    <ng-template pTemplate="toolbar">
                        <div class="upload-toolbar">
                            <span>{{ selectedFileType || 'Select a file type before upload' }}</span>
                            <strong *ngIf="uploadOngoing">{{ uploadProgress }}%</strong>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="content" let-files>
                        <div *ngIf="!filesSelected" class="flex flex-column align-items-center justify-content-center text-center p-5 border-1 border-dashed border-round">
                            <i class="pi pi-upload text-4xl text-primary mb-3"></i>
                            <p class="text-lg font-medium">Drag and drop evidence files here to upload</p>
                            <p class="text-sm text-color-secondary">or</p>
                            <span class="text-sm text-color-secondary">Use Choose to pick files from your device.</span>
                            <span class="text-xs text-color-secondary mt-2">{{ supportedFileHint }}</span>
                        </div>
                        <div *ngIf="uploadedFiles.length > 0" class="upload-list">
                            <div *ngFor="let file of uploadedFiles" class="upload-row">
                                <div class="upload-row-header">
                                    <div class="upload-file-meta">
                                        <i [class]="file.iconClass"></i>
                                        <div>
                                            <strong>{{ file.name }}</strong>
                                            <span>{{ file.size | number }} bytes</span>
                                        </div>
                                    </div>
                                    <span class="upload-status" [class.is-complete]="file.completed" [class.is-failed]="file.status === 'Failed'">
                                        {{ file.status }}
                                    </span>
                                </div>
                                <div class="upload-preview" *ngIf="file.previewUrl" [class.is-open]="file.previewOpened">
                                    <button *ngIf="!file.previewOpened && (file.kind === 'image' || file.kind === 'pdf' || file.kind === 'video')"
                                        type="button" class="upload-preview-trigger" (click)="file.previewOpened = true">
                                        <img *ngIf="file.kind === 'image'" [src]="file.previewUrl" [alt]="file.name" loading="lazy" decoding="async" />
                                        <i *ngIf="file.kind !== 'image'" [class]="file.iconClass"></i>
                                        <span>Preview {{ file.kind }}</span>
                                    </button>
                                    <div *ngIf="file.previewOpened" class="upload-preview-open">
                                        <button type="button" (click)="file.previewOpened = false">Hide preview</button>
                                        <img *ngIf="file.kind === 'image'" [src]="file.previewUrl" [alt]="file.name" decoding="async" />
                                        <video *ngIf="file.kind === 'video'" [src]="file.previewUrl" controls preload="metadata"></video>
                                        <object *ngIf="file.kind === 'pdf'" [data]="file.previewSafeUrl" type="application/pdf">
                                            <a [href]="file.previewUrl" target="_blank" rel="noopener">Open PDF preview</a>
                                        </object>
                                    </div>
                                    <div *ngIf="file.kind !== 'image' && file.kind !== 'pdf' && file.kind !== 'video'" class="upload-preview-placeholder">
                                        <i [class]="file.iconClass"></i>
                                        <strong>{{ file.name }}</strong>
                                        <span>Preview is not available for this file type.</span>
                                        <a [href]="file.previewUrl" target="_blank" rel="noopener">Open file</a>
                                    </div>
                                </div>
                                <p-progressBar [value]="file.progress" [showValue]="true"></p-progressBar>
                                <small *ngIf="file.totalBytes">
                                    {{ file.bytesTransferred || 0 | number }} / {{ file.totalBytes | number }} bytes
                                </small>
                            </div>
                        </div>
                        <div *ngIf="uploadError" class="upload-error">
                            <i class="pi pi-exclamation-triangle"></i>
                            <span>{{ uploadError }}</span>
                        </div>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
    </p-fieldset>
</div>
